export const PREFERENCES_KEY = 'cynoops.live.preferences';
export const DEFAULT_PREFERENCES = Object.freeze({
  theme: 'dark', mapStyle: 'street', labelScale: 1,
  featureLabels: true, trackerLabels: true, teamLabels: true,
  trails: true, teamAreas: true
});

export const normalizePreferences = (value = {}) => {
  const result = { ...DEFAULT_PREFERENCES };
  if (value?.theme === 'light') result.theme = 'light';
  if (['street', 'terrain', 'satellite'].includes(value?.mapStyle)) result.mapStyle = value.mapStyle;
  if (Number.isFinite(value?.labelScale)) result.labelScale = Math.min(1.6, Math.max(0.7, value.labelScale));
  for (const key of ['featureLabels', 'trackerLabels', 'teamLabels', 'trails', 'teamAreas']) {
    if (typeof value?.[key] === 'boolean') result[key] = value[key];
  }
  return result;
};

export const loadPreferences = () => {
  try { return normalizePreferences(JSON.parse(localStorage.getItem(PREFERENCES_KEY) || '{}')); }
  catch { return { ...DEFAULT_PREFERENCES }; }
};
